/// <reference path="../../../../../../node_modules/@types/dom-speech-recognition/index.d.ts" />

export const SpeechRecognition =
  window.SpeechRecognition || (window as any).webkitSpeechRecognition;
export const SpeechGrammarList =
  window.SpeechGrammarList || (window as any).webkitSpeechGrammarList;
